import { useRef, useState } from 'react';
import BugReportSheet from './BugReportSheet';
import './BugReportButton.css';

function BugReportButton() {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    buttonRef.current?.focus();
  };

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        className="bug-report-fab"
        onClick={handleOpen}
        aria-label="¿Tenés un problema con el login u otro error? Reportalo por acá y te ayudamos a la brevedad"
      >
        <span className="bug-report-fab-icon" aria-hidden="true">
          🐞
        </span>
        <span className="bug-report-fab-label">
          ¿Tenés un problema con el login u otro error? Reportalo acá
        </span>
      </button>

      <BugReportSheet isOpen={isOpen} onClose={handleClose} />
    </>
  );
}

export default BugReportButton;
